import Vue from "vue";
import { setStore, getStore, clearStore } from "../../config/mUtils";
import { prefix } from "../../config/env";

const STAGE_SUBJECT_IN = "STAGE_SUBJECT_IN"; // 写入
const STAGE_SUBJECT_OUT = "STAGE_SUBJECT_OUT"; // 删除写入
export default {
  state: JSON.parse(getStore(`${prefix}stage_subject`)) || null,
  mutations: {
    [STAGE_SUBJECT_IN](state, data) {
      Object.assign(state, data);
      let stringify = JSON.stringify(data);
      setStore(`${prefix}stage_subject`, stringify);
    },
    [STAGE_SUBJECT_OUT](state) {
      clearStore();
      Object.keys(state).forEach((k) => Vue.delete(state, k));
    },
  },
  actions: {
    [STAGE_SUBJECT_IN]({ commit }, data) {
      commit(STAGE_SUBJECT_IN, data);
    },
    [STAGE_SUBJECT_OUT]({ commit }) {
      commit(STAGE_SUBJECT_OUT);
    },
  },
};
